import React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface FormTabsProps {
  tab: 'stockistDetails' | 'branches' | 'products';
  add: boolean;
  onTabChange: (e: any, value: 'stockistDetails' | 'branches' | 'products') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor="primary">
        <Tab value="stockistDetails" label={t('stockists.addEdit.pageTexts.form.tabs.stockistDetails')} />
        {!add && <Tab value="branches" label={t('stockists.addEdit.pageTexts.form.tabs.branches')} />}
        {!add && <Tab value="products" label={t('stockists.addEdit.pageTexts.form.tabs.products')} />}
      </Tabs>
    </div>
  );
};

export default FormTabs;
